import { toast } from "react-toastify";

export default async function ToastError(value) {
  await Object.keys(value).map((errorField) => {
    return toast.error(value[errorField][0]);
  });
}